module.exports = __webpack_public_path__ + "static/media/banner3.079bfda0.png";